import { renderToStaticMarkup } from '@web-stories-wp/react';
import FontDeclarations from './FontDeclarations';

// JSON-based generation only consumes the font declarations from content.
// Full AMP exports still use getStoryMarkup and its prepared effect images.
export default function getStorySaveMarkup({ pages }) {
  return renderToStaticMarkup(
    <html>
      <head>
        <FontDeclarations pages={pages} />
      </head>
      <body />
    </html>
  );
}
